import { useCallback, useState } from 'react';
import { Patient } from 'api/account/patients.type';
import { BackArrowButton } from 'components/_global/back-button/BackArrowButton';
import { Slot } from 'components/_temp_ui_common/api/getAvailability';
import { Appointment } from 'components/_temp_ui_common/Appointments/types';
import { CalendarConfirmation } from 'components/_temp_ui_common/Calendar/CalendarConfirmation';
import { preferredName } from 'components/_temp_ui_common/utilities/preferredName';
import { SubmitButton } from 'components/core/button/Button';
import { Checkbox } from 'components/core/checkbox/Checkbox';

export interface ReviewAndConfirmSelectedSlotProps {
  appointment: Appointment;
  member: Patient;
  selectedSlot: Slot;
  onCancel: () => void;
  onError: () => void;
  onConfirm: () => void;
}

export const ReviewAndConfirmSelectedSlot = ({
  appointment,
  member,
  selectedSlot,
  onCancel,
  onError,
  onConfirm,
}: ReviewAndConfirmSelectedSlotProps) => {
  const [caregiverTermsAccepted, setCaregiverTermsAccepted] = useState(false);
  const hasCaregiverTerms = member.age < 18;
  const onBackButtonClick = useCallback(() => {
    setCaregiverTermsAccepted(false);
    onCancel();
  }, [onCancel]);
  return (
    <CalendarConfirmation
      slot={selectedSlot}
      appointment={appointment}
      BackButton={
        <BackArrowButton
          style={{ alignSelf: 'start' }}
          onClick={onBackButtonClick}
        />
      }
      onError={onError}
      ConfirmButton={
        <SubmitButton
          onClick={onConfirm}
          disabled={hasCaregiverTerms && !caregiverTermsAccepted}
        >
          Confirm
        </SubmitButton>
      }
      ConfirmPreamble={
        hasCaregiverTerms ? (
          <Checkbox
            label={`I understand that ${preferredName(member)} and an adult caregiver are required to be at this session.`}
            onClick={() => setCaregiverTermsAccepted(!caregiverTermsAccepted)}
            className="Checkbox--fullWidth mb-4"
            data-testid="caregiver-terms-accepted-checkbox"
          />
        ) : undefined
      }
    />
  );
};
